import React, { createContext, useContext, useState, useEffect } from "react";
import { getPermissions, markFirstLoginCompleted } from "./api";

const UserRoleContext = createContext();

const fetchPermissions = async () => {
  try {
    const response = await getPermissions();
    return {
      role: response.role,
      permissions: response.permissions,
      isFirstLogin: response.isFirstLogin || false
    };
  } catch (error) {
    console.error("Error al obtener permisos:", error);
    return {
      role: null,
      permissions: [],
      isFirstLogin: false
    };
  }
};

export const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadRoleAndPermissions = async () => {
      try {
        setIsLoading(true);
        const { role, permissions, isFirstLogin } = await fetchPermissions();
        setUserRole(role);
        setPermissions(permissions);
        setIsFirstLogin(isFirstLogin);
      } catch (error) {
        console.error("Error cargando permisos:", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadRoleAndPermissions();
  }, []);
  
  const hasPermission = (permission) => {
    if (isLoading || !permissions) return false;
    return permissions.includes(permission);
  };

  const markFirstLoginComplete = async () => {
    try {
      setIsFirstLogin(false);
      await markFirstLoginCompleted();
    } catch (error) {
      console.error("Error al marcar primer login completado:", error);
    }
  };
  
  return (
    <UserRoleContext.Provider value={{ 
      userRole,
      roleName: userRole ? userRole : "Invitado",
      permissions,
      hasPermission,
      isLoading,
      isFirstLogin,
      markFirstLoginComplete
    }}>
      {children}
    </UserRoleContext.Provider>
  );
};

export const useUserRole = () => useContext(UserRoleContext);